import HeaderInputSearch from "./header-inputsearch";
import { useEffect } from "react";

const HearderSearch = ({
  showPopover,
  searchedArrayWork,
  searchedArrayComposer,
  isClickedBtn,
  searchString,
  hearderRef,
  setIsClickedBtn,
  setSearchString,
  setShowPopover,
  handleDisplaySearchResult,
  setSearchedArrayComposer,
  setSearchedArrayWork,
  allComposers,
  allWorks,
  activeComposerMenu,
  activeWorkMenu,
}) => {
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        showPopover &&
        hearderRef.current &&
        !hearderRef.current.contains(e.target)
      ) {
        setShowPopover(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showPopover]);

  useEffect(() => {
    if (searchString !== "") {
      setShowPopover(true);

      if (isClickedBtn === activeComposerMenu && showPopover) {
        const searchedObjects = [];

        allComposers.forEach((itemComposer) => {
          if (
            itemComposer?.firstName
              ?.toLowerCase()
              .includes(searchString.toLowerCase())
          ) {
            searchedObjects.push(itemComposer);
            return;
          }
          if (
            itemComposer?.lastName
              ?.toLowerCase()
              .includes(searchString.toLowerCase())
          ) {
            searchedObjects.push(itemComposer);
            return;
          }
          if (
            itemComposer?.dateOfBirth
              ?.toLowerCase()
              .includes(searchString.toLowerCase())
          ) {
            searchedObjects.push(itemComposer);
            return;
          } else if (
            itemComposer?.dateOfDeath
              ?.toLowerCase()
              .includes(searchString.toLowerCase())
          ) {
            searchedObjects.push(itemComposer);
            return;
          }
        });
        setSearchedArrayComposer(searchedObjects);
      } else if (isClickedBtn === activeWorkMenu && showPopover) {
        let searchedWork = [];
        const firstString = searchString?.split(" ")[0];
        const secondString = searchString?.split(" ")[1];

        allWorks.forEach((itemWork) => {
          const { firstName, lastName, typeChoosen, title } = itemWork;

          // When init search matched on composer only
          if (
            !secondString &&
            (firstName?.toLowerCase().includes(searchString.toLowerCase()) ||
              lastName?.toLowerCase().includes(searchString.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }

          // When init search matched on work only
          else if (
            !secondString &&
            (title?.toLowerCase().includes(searchString.toLowerCase()) ||
              typeChoosen?.toLowerCase().includes(searchString.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }

          // When search[0] search matched on composer
          else if (
            firstString &&
            (firstName?.toLowerCase().includes(firstString?.toLowerCase()) ||
              lastName?.toLowerCase().includes(firstString.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }

          // When search[0] matched on work
          else if (
            secondString &&
            (title?.toLowerCase().includes(secondString?.toLowerCase()) ||
              typeChoosen?.toLowerCase().includes(secondString?.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }

          // When search[1] search matched on composer
          else if (
            firstString &&
            (firstName?.toLowerCase().includes(firstString?.toLowerCase()) ||
              lastName?.toLowerCase().includes(firstString?.toLowerCase())) &&
            (title?.toLowerCase().includes(secondString?.toLowerCase()) ||
              typeChoosen?.toLowerCase().includes(secondString?.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }

          // When search[1] matched on work
          else if (
            secondString &&
            (title?.toLowerCase().includes(secondString?.toLowerCase()) ||
              typeChoosen
                ?.toLowerCase()
                .includes(secondString?.toLowerCase())) &&
            (firstName?.toLowerCase().includes(firstString.toLowerCase()) ||
              lastName?.toLowerCase().includes(firstString.toLowerCase()))
          ) {
            searchedWork.push(itemWork);
            return;
          }
        });

        let sortedWorks = [];
        setTimeout(() => {
          const composerRegex = new RegExp(firstString, "gi");
          const titleRegex = new RegExp(secondString, "gi");

          const scoreCalculator = (item) => {
            const fullname =
              (item.firstName || "") + " " + (item.lastName || "");

            const composerScore = (fullname.match(composerRegex) || []).length;

            const titleScore = true
              ? ((item.title || "").match(titleRegex) || []).length
              : 0;

            const score =
              composerScore > 0 && titleScore > 0
                ? Number.POSITIVE_INFINITY
                : composerScore + titleScore;
            return { composerScore, titleScore, totalScore: score };
          };

          // sortedWorks = [...searchedWork].map((e) => {
          //   e.score = scoreCalculator(e);
          //   return e;
          // });

          sortedWorks = [...searchedWork].sort((a, b) => {
            a.score = scoreCalculator(a);
            b.score = scoreCalculator(b);
            if (a.score.totalScore < b.score.totalScore) {
              return 1;
            }
            if (a.score.totalScore > b.score.totalScore) {
              return -1;
            }
            return 0;
          });

          // console.log("searchedWork :>> ", sortedWorks);
          setSearchedArrayWork(sortedWorks);
        }, 200);
      }
    }
  }, [searchString]);

  return (
    <div className="relative">
      <img
        src="https://piano-piano.org/oppdb/images/assets/bg.jpeg"
        className="absolute inset-0 object-right object-cover w-full h-full"
        alt="background"
      />
      <div className="relative pb-4 md:py-16 bg-gray-600 bg-opacity-75">
        <div>
          <HeaderInputSearch
            showPopover={showPopover}
            handleDisplaySearchResult={handleDisplaySearchResult}
            handleClick={() => setShowPopover(true)}
            setInputValue={(e) => setSearchString(e.target.value)}
            dataSearchWork={searchedArrayWork}
            dataSearchComposer={searchedArrayComposer}
            isClickedBtn={isClickedBtn}
            value={searchString}
            handleClickWork={() => setIsClickedBtn(1)}
            handleClickComposer={() => setIsClickedBtn(2)}
            myRef={hearderRef}
          />
        </div>
      </div>
    </div>
  );
};

export default HearderSearch;
